module.exports = __webpack_public_path__ + "img/HEP_NAVIO_en.32893885.jpg";